SET_USER_VIDEO_ID_PATH